import { render, staticRenderFns } from "./AlertCadastroNaoAtivo.vue?vue&type=template&id=0451bcdb&"
import script from "./AlertCadastroNaoAtivo.vue?vue&type=script&lang=js&"
export * from "./AlertCadastroNaoAtivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports